import { render, staticRenderFns } from "./Thing.vue?vue&type=template&id=37f184c6"
import script from "./Thing.vue?vue&type=script&lang=js"
export * from "./Thing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports